import React from 'react';
import { Typography, Box } from '@material-ui/core';
import * as BasicWidgets from './BasicWidgets';
import * as ChartWdigets from './ChartWidgets';
import * as FormWidgets from './FormWidgets';

function UnsupportedWidget({ width, height, type, ...props }) {
  return (
    <Box
      width={width}
      height={height}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {/* <Typography>
        Unsupported card widget: {type} - {JSON.stringify(props)}
      </Typography> */}
    </Box>
  );
}

const widgets = {
  card_1: BasicWidgets.HeadingWidget,
  card_2: BasicWidgets.HeadingWidget,
  card_3: BasicWidgets.HeadingWidget,
  card_4: BasicWidgets.KeyValueWidget,
  card_5: BasicWidgets.DescriptionWidget,
  card_6: BasicWidgets.StateWidget,
  card_7: BasicWidgets.AvatarWidget,
  card_8: BasicWidgets.AvatarWidget,
  card_9: BasicWidgets.AvatarWidget,
  card_10: BasicWidgets.AvatarWidget,
  card_11: BasicWidgets.AvatarWidget,
  card_14: BasicWidgets.TimeIconWidget,
  card_16: BasicWidgets.FourBoxWidget,
  card_105: BasicWidgets.FourBoxWidget,
  card_24: BasicWidgets.DescriptionWidget,
  card_25: BasicWidgets.StateWidget,
  card_26: BasicWidgets.StatesWidget, // TODO: deeplink handling
  card_28: BasicWidgets.FileWidget, // TODO: deeplink handling
  card_29: FormWidgets.ChecklistRadioWidget,
  card_31: FormWidgets.ChecklistTextWidget,
  card_34: FormWidgets.InputTextWidget,
  card_35: FormWidgets.DropdownWidget,
  card_45: FormWidgets.DropdownWidget,
  card_36: FormWidgets.HorizontalRadioWidget,
  card_37: FormWidgets.RadioWidget,
  card_38: BasicWidgets.KeyValueWidget, // TODO: change this
  card_39: FormWidgets.InputDateWidget,
  card_65: FormWidgets.InputDateWidget,
  card_41: BasicWidgets.HeadingWidget, // TODO: change this
  card_42: BasicWidgets.KeyValueWidget,
  card_43: BasicWidgets.DescriptionWidget, // TODO: change this
  card_44: BasicWidgets.DescriptionWidget, // TODO: change this
  card_48: BasicWidgets.DescriptionWidget,
  card_49: FormWidgets.ChecklistOptionWidget,
  card_50: () => <></>, // show nothing
  card_53: BasicWidgets.FullwidthTitlebarWidget,
  card_54: BasicWidgets.TitlebarWidget,
  card_55: BasicWidgets.Attendance2EventsWidget,
  card_56: BasicWidgets.AttendanceWidget,
  card_57: FormWidgets.LocationPicker,
  card_77: FormWidgets.CheckboxInputWidget,
  card_88: BasicWidgets.TitleSubtitleMenuWidget,
  card_98: FormWidgets.MultipleTextInput,
  card_100: ChartWdigets.PieChartWidget,
  card_101: ChartWdigets.BarChartWidget,
  card_102: BasicWidgets.BoxWidget,
  card_103: ChartWdigets.TableWidget,
  card_104: BasicWidgets.BoxRowsWidget,
  card_105: BasicWidgets.GradientCardWidget,
  card_106: BasicWidgets.FileUploadWidget,
  card_109: BasicWidgets.ProgressActionHeadingWidget,
  card_110: FormWidgets.SelectableCardWidget,
  card_111: BasicWidgets.ActionButtonsWidget,
  card_115: FormWidgets.DropdownWidgetLarge,
  card_117: FormWidgets.MultipleDatePicker,
  card_116: FormWidgets.MultipleSelection,
  card_118: BasicWidgets.ModulesWidget,
  card_119: FormWidgets.GoalWidget,
  card_126: BasicWidgets.ModuleRowWidget,
  card_121: BasicWidgets.EmptyModulesWidget,
  card_125: FormWidgets.TextInputWidgetLarge,
  card_79: FormWidgets.DropdownWidget,
  card_107: BasicWidgets.SingleGradientBox,
  card_74: FormWidgets.ChipActionWidget,
  card_130: BasicWidgets.HyperlinkWidget,
  card_59: FormWidgets.ChipSelectionInputWidget,
  card_127: FormWidgets.NestedDropdownWidget,
  card_128: FormWidgets.ExtensibleFormWidget,
  card_94: BasicWidgets.PartitionedDisplayWidget,
  card_75: BasicWidgets.ParagraphWidget,
  card_52: BasicWidgets.TimelineBlockCard,
  card_135: BasicWidgets.StepFlowWidget, //TODO change card number in backend
  card_129: FormWidgets.CardTemplateFormWidget,
  card_134: BasicWidgets.IconWithMessage, //TODO change card number in backend
  card_131: BasicWidgets.SuccessMessage,
  card_132: BasicWidgets.BillingScreen,
  card_133: BasicWidgets.InfoWithIconCardWidget,
  card_136: FormWidgets.MobileSearchAndOrderWidget,
  card_137: FormWidgets.FileUploadWidget,
  card_138: BasicWidgets.WaitingPreview,
  card_140: BasicWidgets.WebStoreBanner,
  card_139: FormWidgets.OtpWidget,
  card_998: FormWidgets.CartWidget,
  card_999: FormWidgets.ProductSearchWithCartWidget,
  card_141: FormWidgets.GoogleLocationPicker,
  card_142: FormWidgets.GoogleLocationPlusAddress,
  card_143: FormWidgets.LocationSearchWidget,
  card_144: FormWidgets.DescriptiveDropdownWidget,
  card_145: BasicWidgets.ButtonsGroupWidget,
  card_149: FormWidgets.EditableDropdownWidget,
  card_147: BasicWidgets.ImagesWidget,
  card_148: BasicWidgets.TitleSubtitleCarouselWidget,
  card_146: FormWidgets.TrackingMap,
  card_150: BasicWidgets.TimelineCard,
  card_151: BasicWidgets.DescriptionWithIconButtonWidget,
  card_152: FormWidgets.InputSearchField,
};

export function CardWidget(props) {
  const WidgetComponent = widgets[props.card_content_type] || UnsupportedWidget;
  const [isMobile, setIsMobile] = React.useState(false);
  const handleResize = () => {
    if (window.innerWidth < 600) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  React.useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  });
  // const {deep_link, handleDeeplink, setDeepLink, overrideHandleDeepLink} = props;
  return (
    // <Box p={1} onClick={() => deep_link && (overrideHandleDeepLink ? setDeepLink: handleDeeplink)(deep_link, props)}>
    <WidgetComponent isMobile={isMobile} {...props} />
    // </Box>
  );
}
